<template>
	<div ref="howItWorks">
		<slot></slot>
	</div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref, nextTick } from 'vue'
import { onResize } from '@js/throttle'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const howItWorks = ref(null)

function drawBoxes(box, progress) {
	const svg = box.querySelector('svg');
	box.style.setProperty('--progress', `${progress * 100}%`);
	if (progress == 0) {
		svg.classList.add('opacity-0');
		box.querySelector('div:first-child').classList.add('opacity-0');
	} else {
		svg.classList.remove('opacity-0');
		box.querySelector('div:first-child').classList.remove('opacity-0');
	}
	gsap.to(svg.querySelector('path'), {
		drawSVG: `${50 - (progress * 100) / 2}% ${50 + (progress * 100) / 2}% live`,
		duration: 0
	});
}

function updateBoxes() {
	const boxes = howItWorks.value.querySelectorAll('.hiw-box');
	gsap.utils.toArray(boxes).forEach(box => {
		const svg = box.querySelector('svg');
		gsap.to(svg.querySelector('path'), {
			drawSVG: `50% 50%`,
			duration: 0
		});

		ScrollTrigger.create({
			trigger: box,
			start: 'top center',
			end: 'bottom center',
			onUpdate: (self) => {
				drawBoxes(box, self.progress);
			},
			onRefresh: (self) => {
				drawBoxes(box, self.progress);
			},
			markers: false
		});
	});
}

function drawLines(line, progress) {
	line.style.setProperty('--progress', `${progress * 100}%`);
}

function updateLines() {
	const lines = howItWorks.value.querySelectorAll('.hiw-line');
	gsap.utils.toArray(lines).forEach(line => {
		ScrollTrigger.create({
			trigger: line,
			start: 'top center',
			end: 'bottom center',
			onUpdate: (self) => {
				drawLines(line, self.progress);
			},
			onRefresh: (self) => {
				drawLines(line, self.progress);
			},
			markers: false
		});
	});
}

// let imageSectionScrollTrigger = null; // Store reference to ScrollTrigger instance

// function updateImageSectionPinning() {
// 	if (imageSectionScrollTrigger) {
// 		imageSectionScrollTrigger.kill(); // Kill existing ScrollTrigger
// 	}

// 	const stepsContainer = howItWorks.value.querySelector('.hiw-steps-container');
// 	const imageContainer = howItWorks.value.querySelector('.hiw-image-container');
// 	const sampleImage = howItWorks.value.querySelector('.hiw-image-container img');

// 	// Ensure all elements exist
// 	if (!stepsContainer || !imageContainer || !sampleImage) return;

// 	const topPadding = stepsContainer.offsetTop - imageContainer.offsetTop;
// 	const stepsHeight = stepsContainer.offsetHeight;
// 	const sampleImageHeight = sampleImage.offsetHeight;

// 	imageSectionScrollTrigger = ScrollTrigger.create({
// 		trigger: stepsContainer,
// 		start: 'top center',
// 		end: `+=${((stepsHeight - sampleImageHeight) / 2) + topPadding}px center`,
// 		pin: imageContainer
// 	});
// }

function moveImages(image, progress) {
	image.style.setProperty('--progress', `${progress}`);
}

function updateImages() {
	const images = howItWorks.value.querySelectorAll('.hiw-image-container > div');
	const boxes = howItWorks.value.querySelectorAll('.hiw-box');
	gsap.utils.toArray(images).forEach((image, i) => {
		ScrollTrigger.create({
			trigger: boxes[i + 1],
			start: 'top-=30px center',
			end: 'bottom+=30px center',
			onUpdate: (self) => {
				moveImages(image, self.progress);
				// imageSectionScrollTrigger.refresh();
			},
			onRefresh: (self) => {
				moveImages(image, self.progress);
			},
			markers: false
		});
	});
}

onMounted(() => {
	updateBoxes();
	updateLines();
	// updateImageSectionPinning();
	updateImages();

	// onResize(() => {
	// 	updateImageSectionPinning();
	// })
});

onBeforeUnmount(() => {
	// if (imageSectionScrollTrigger) {
	// 	imageSectionScrollTrigger.kill();
	// }
});
</script>
